export const types = {
  ACTIVATE_SENSOR: "ACTIVATE_SENSOR",
  ACTIVATE_SENSOR_SUCCESS: "ACTIVATE_SENSOR_SUCCESS",
  SET_SHOW_SENSOR_ACTIVATE_MODAL: "SET_SHOW_SENSOR_ACTIVATE_MODAL",
  ACTIVATE_BLE_SENSOR: "ACTIVATE_BLE_SENSOR",
};

export const activateSensor = (sensors, callback) => {
  return {
    type: types.ACTIVATE_SENSOR,
    sensors,
    callback,
  };
};

export const setShowSensorActivateModal = (modalState, callback) => {
  return {
    type: types.SET_SHOW_SENSOR_ACTIVATE_MODAL,
    modalState,
    callback,
  };
};

export const setActiveBleTag = (state, callback) => {
  return {
    type: types.ACTIVATE_BLE_SENSOR,
    state,
    callback,
  };
};
